/**
 * Admin Level Utilities
 *
 * Shared helpers for rendering admin level badges and labels.
 */

import { Users, Building2, MapPin, type LucideIcon } from "lucide-react";
import type { AdminLevel } from "@/services/adminService";

export function getLevelLabel(level: AdminLevel | string): string {
  switch (level) {
    case "nasional":
      return "Nasional";
    case "province":
      return "Provinsi";
    case "city":
      return "Kota/Kabupaten";
    default:
      return level;
  }
}

export function getLevelIcon(level: AdminLevel | string): LucideIcon {
  switch (level) {
    case "nasional":
      return Users;
    case "province":
      return Building2;
    case "city":
      return MapPin;
    default:
      return Users;
  }
}

export function getLevelColor(level: AdminLevel | string): string {
  switch (level) {
    case "nasional":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 border-blue-200 dark:border-blue-800";
    case "province":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200 border-green-200 dark:border-green-800";
    case "city":
      return "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200 border-purple-200 dark:border-purple-800";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200 border-gray-200 dark:border-gray-800";
  }
}

export function formatPrivilege(privilege: string): string {
  return privilege.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
}
